export default __webpack_public_path__ + "static/media/union-pay.5d5e238a.svg";